import { createFileRoute } from '@tanstack/react-router';
import { capitalize } from 'lodash-es';

import { RealType } from 'helpers/getRealType';

export const Route = createFileRoute('/_auth/_buttonView/_layout/resources/_type/$type')({
  staticData: {
    disableTitleLink: true,
  },
  parseParams: (params) => {
    const typeToCheck = params.type as RealType;

    if (typeToCheck === RealType.PROMOTE || typeToCheck === RealType.SELL) {
      return params as { type: RealType };
    }

    throw new Error('Invalid type'); // TODO: Replace with app exception
  },
  context: (ctx) => {
    return {
      title: capitalize(ctx.params.type) as string,
    };
  },
});
